import type { RouteRecord } from 'vite-react-ssg';
import RootLayout from './components/RootLayout';
import { App } from './App';
import DiscoverIndex from './pages/DiscoverIndex';
import Category from './pages/Category';
import Place from './pages/Place';
import { CATEGORIES, LISTINGS } from './directory/data';

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <RootLayout />,
    entry: 'src/components/RootLayout.tsx',
    children: [
      { index: true, Component: App },
      { path: 'discover', Component: DiscoverIndex },
      {
        path: 'discover/:category',
        Component: Category,
        // Pre-render one page per activity.
        getStaticPaths: () => CATEGORIES.map((c) => `discover/${c.key}`),
      },
      {
        path: 'discover/:category/:slug',
        Component: Place,
        // Pre-render one page per listing.
        getStaticPaths: () => LISTINGS.map((l) => `discover/${l.category}/${l.slug}`),
      },
    ],
  },
];
